import { render, staticRenderFns } from "./nosAtouts.vue?vue&type=template&id=ab7e2e68"
import script from "./nosAtouts.vue?vue&type=script&lang=js"
export * from "./nosAtouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderLesAtouts: require('/home/etienne/AM-frontend/components/HeaderLesAtouts.vue').default})
